import type { FC, ReactNode } from 'react'
import type { LegalSection } from '@/components/landing/legal-page'

import LegalPage from '@/components/landing/legal-page'

const SECTIONS: LegalSection[] = [
    {
        id: 'scope',
        heading: 'What these terms cover',
        paragraphs: [
            'These terms apply to the Rare Frequency Works website, its free browser tools, and the product information published here.'
        ]
    },
    {
        id: 'your-use',
        heading: 'Your use and your content',
        paragraphs: [
            'You may use the tools for lawful personal or business purposes. You keep ownership of your files, and you must have permission to use any file you work with.'
        ],
        bullets: [
            'Do not use the tools to spread harmful files or break the law.',
            "Do not infringe other people's rights.",
            'Do not disrupt the service or try to access it without permission.'
        ]
    },
    {
        id: 'originals',
        heading: 'Keep and review your originals',
        paragraphs: [
            'Results can vary with the file, device, browser and settings. Keep your original file and check the saved copy before you rely on it. Converting, compressing and removing metadata can permanently discard information.'
        ]
    },
    {
        id: 'free-and-paid',
        heading: 'Free and paid access',
        paragraphs: [
            'The browser tools on this website are free and need no account.',
            'DOCSCRUB has a free version that includes 3 successful saves per day where offered. DOCSCRUB Premium adds unlimited saves and the premium tools, and costs $5.99 a month or $39.99 a year in USD before any taxes or local pricing shown by the store.',
            'Premium is sold only inside the Android app through Google Play and inside the Windows app through the Microsoft Store. The web version of DOCSCRUB is free and has no Premium purchase. Purchases do not transfer between platforms.',
            'Prices, taxes, renewals, trials, cancellations, refunds and restoring purchases are handled under the terms of the store you bought from. A one-time purchase offered on a platform applies to that platform only and is not a promise of uninterrupted service forever. These terms do not reduce any rights you have under your purchase terms or the law.'
        ]
    },
    {
        id: 'radar',
        heading: 'Morpho Radar',
        paragraphs: [
            'Morpho Radar shows information about Morpho Blue positions. It does not move funds or manage positions, and it is not financial advice. The price of a live query is shown before you approve the payment. Morpho Radar is an independent tool and is not an official Morpho product.'
        ]
    },
    {
        id: 'availability',
        heading: 'Availability and third parties',
        paragraphs: [
            'Features may change, and the service may sometimes be unavailable. Hosting, app stores, payment providers and blockchain networks are run by third parties under their own terms.',
            'The tools and guides are provided for general information and are not professional advice.'
        ]
    },
    {
        id: 'liability',
        heading: 'Results and your legal rights',
        paragraphs: [
            'To the extent the law allows, the tools are provided as available, without a promise that every result will be error free or suit every purpose. Nothing in these terms limits rights that cannot lawfully be excluded.'
        ]
    },
    {
        id: 'changes',
        heading: 'Changes to these terms',
        paragraphs: [
            'If these terms change, we will update this page and the date at the top.'
        ]
    }
]

const TermsPage: FC = (): ReactNode => (
    <LegalPage
        seoTitle='Terms of use'
        description='Terms of use for the Rare Frequency Works website, free browser tools, DOCSCRUB and Morpho Radar.'
        eyebrow='Rare Frequency Works'
        title='Terms of use'
        tagline='Clear expectations for useful tools.'
        updated='November 2, 2026'
        sections={SECTIONS}
    />
)

export default TermsPage
